import React,{Fragment,useRef,useState,useEffect} from 'react';
import classes from './Seller.module.css';
import BottomBgm from '../../assets/bottom_right.png';
import axios from "axios";
import useGeoLocation from '../../hooks/useGeoLocation';
import VerifyIcon from '../../assets/correct.png';
import S3FileUpload from 'react-s3';
import { Buffer } from 'buffer';
import usePlacesAutocomplete, {
  getGeocode,
  getLatLng,
} from "use-places-autocomplete";
import useOnclickOutside from "react-cool-onclickoutside";
import {GoogleMap,LoadScript,Marker} from '@react-google-maps/api'; 
import Select from 'react-select';
import DatePicker from 'react-date-picker';
import OTPInput, { ResendOTP } from "otp-input-react";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import AuthLogo from '../../assets/authentication.jpg';

const containerStyle = {
  width: "100%",
  height: "190px",
};

// const API_URL = "http://demo.autozilla.co/";
// const S3_BUCKET_NAME = "az-dev-images-azvpc";

// const API_URL = "https://preprod.autozilla.co/";
// const S3_BUCKET_NAME = "az-uat-images-azvpc";

const API_URL = "https://app.autozilla.co/";
const S3_BUCKET_NAME = "az-prd-images-azvpc";

const SellerForm = props =>{
	
	const stateData = [];
	const cityData = [];
	const brandData = [];
	const categoryData = [];
	const payTermData = [];
	const [map, setMap] = useState(null);
	const [currentLoc, setCurrentLoc] = useState({lat: '17.4357012',lng: '78.3599279'});
	const [states,SetStates] = useState(stateData);
	const [cities,SetCities] = useState(cityData);
	const [brands,SetBrands] = useState(brandData);
	const [categories,SetCategories] = useState(categoryData);
	const [paymentTerms,SetPaymentTerms] = useState(payTermData);
	const [pictures,setPictures] = useState([]);
	const [dateValue, dateChangeHandler] = useState(new Date());
	const [weddingDateValue, weddingDateChangeHandler] = useState(new Date());
	const [appendAddress,SetAppendAddress] = useState('');
	const [catalogAvailable,SetCatalogAvailable] = useState('No');
	const [logisticalSupport,SetLogisticalSupport] = useState('No');
	const [apiIntegration,SetApiIntegration] = useState('No');
	const [willingToUse,SetWillingToUse] =  useState('No');
	const [stockUpdate,SetStockUpdate] = useState('No');
	const [selectedPaymentTerm,SetSelectedPaymentTerm] = useState('');
	const [selectedCategories,SetSelectedCategories] = useState('');
	const [selectedBrands,SetSelectedBrands] = useState('');
	const [gstNo,SetGstNo] = useState('');
	const [gstExist,SetGstExist] = useState(false);
	const [mobileVerified,SetMobileVerified] = useState(false);
	const [mobileValid,SetMobileValid] = useState(true);
	const [mobileNo,SetMobileNo] = useState('');
	const [managerContact,SetManagerContact] = useState('');
	const [OTP, sellerOTP] = useState("");
	const [showOtpInput,SetShowOtpInput] = useState(false);
	const [otpSent,SetOtpSent] =  useState('');
	const [otpMatched,SetOtpMatched] = useState(true); 
	const [customerExist,SetCustomerExist] = useState(false);
	const [formIsValid,SetFormIsValid] = useState(true);
	const [postcode,SetPostcode] = useState('');
	const [errors,SetErrors] = useState(
		{
			NameError : false,
			areaOperationsError:false,
			ownerEmailError:false,
			ownerContactNumError:false,	
			ownerNameError:false,
			managerContactError:false,
			managerEmailError:false,
			addressError:false,
			stateError:false,
			cityError:false,
			zipError:false,		
		}
	);
	window.Buffer = window.Buffer || require("buffer").Buffer;

	const enteredName = useRef();
	const enteredAreaOfOperations = useRef();
	const enteredOwnerContactNumber = useRef();
	const enteredOwnerName = useRef();
	const enteredOwnerEmailId = useRef();
	const enteredManagerContactNumber = useRef();
	const enteredManagerEmailId = useRef();
	const enteredGstNumber = useRef();
	
	const enteredAddress = useRef();	
	const enteredCity = useRef();
	const enteredState = useRef();
	const enteredZipcode = useRef();
	const enteredGeocode = useRef();	
	const enteredFieldSalesStaff = useRef();
	const enteredLocalSalesStaff = useRef();
	const enteredDiscount = useRef();
	const enteredCurrentSystem = useRef();
	const enteredOwnerBirthday = useRef();
	const enteredOwnerWedding = useRef();	
	const enteredManagerName = useRef();
	const enteredBusinessType = useRef();
	const enteredDiscountType = useRef();
	const enteredLandMark = useRef();
		useEffect(() => {		
			navigator.geolocation.getCurrentPosition((position) => {
				 setCurrentLoc({
				   lat: position.coords.latitude,
				   lng: position.coords.longitude,
				 });
				 formattedAddress(position.coords.latitude,position.coords.longitude);		
			});
		},[]);
		useEffect(() => {
		axios.get(API_URL+'pos/api/States',{
		  auth: {
			username: 'az_live@autozilla.com',
			password: '4cslC166sb2A63FmO7Jh65z0N3Zh1ZL8'
		  }
		})
		.then(res => {
			const statesResp = res.data; 		
			SetStates(statesResp);
		  
		});
		
		},[]);
		
		useEffect(() => {
		axios.get(API_URL+'pos/api/Brands?search',{
		  auth: {
			username: 'az_live@autozilla.com',
			password: '4cslC166sb2A63FmO7Jh65z0N3Zh1ZL8'
		  }
		})
		.then(res => {
			const brandResp = res.data;
			 let brandArrObj = [];
			brandResp.forEach((val) => {
				brandArrObj.push({
					  value: val.brand_id,
					  label:val.brand_name
					});
			});	
			
			SetBrands(brandArrObj);
		  
		});
		
		},[]);
		
		useEffect(() => {
		axios.get(API_URL+'pos/api/Category?level=1',{
		  auth: {
			username: 'az_live@autozilla.com',
			password: '4cslC166sb2A63FmO7Jh65z0N3Zh1ZL8'
		  }
		})
		.then(res => {
			const catResp = res.data;
			SetCategories(catResp);
		  
		});
		
		},[]);

		useEffect(() => {
			axios.get(API_URL+'pos/api/PaymentTerms',{
			  auth: {
				username: 'az_live@autozilla.com',
				password: '4cslC166sb2A63FmO7Jh65z0N3Zh1ZL8'
			  }
			})
			.then(res => {
				const paytermsResp = res.data; 			
				SetPaymentTerms(paytermsResp);
			  
			});
			
			},[]);

		
		
		
		const stateSelectHandler =(event)=>{
			const selectedStateId = event.target.value;
			
			axios.get(API_URL+'pos/api/Cities?state_id='+selectedStateId,{
			  auth: {
				username: 'az_live@autozilla.com',
				password: '4cslC166sb2A63FmO7Jh65z0N3Zh1ZL8'
			  }
			})
			.then(res => {
				const cityResp = res.data; 			
				SetCities(cityResp);
				SetErrors({...errors, cityError: false});		  
			});
		}
		
		const logisticalChangeHandler = (e) =>{
			SetLogisticalSupport(e.target.value);			
		}
		const catalogAvailChangeHandler = (e) =>{
			SetCatalogAvailable(e.target.value);			
		}
		
		
		const categorySelectHandler = (selectedOption )=>{
			//console.log(selectedOption);
			var catStr = '';
			selectedOption.forEach((category) => {
				catStr += category.value+',';
			});
			SetSelectedCategories(catStr);
		}
		const brandSelectHandler = (selectedOption )=>{
			var brndStr = '';
			selectedOption.forEach((brand) => {
				brndStr += brand.value+',';
			});
			SetSelectedBrands(brndStr);
		}
		
		const paymentTermsSelectHandler = (selectedOption )=>{
			SetSelectedPaymentTerm(selectedOption.value);
		}
		const businessTypeSelectHandler = (e)=>{
			//console.log(e.target.value);
		}

		const apiIntegrationChangeHandler = (e) =>{
			SetApiIntegration(e.target.value);
		}
		const willingtoUseChangeHandler=(e)=>{
			SetWillingToUse(e.target.value);
		}
		const stockUpdateChangeHandler=(e)=>{
			SetStockUpdate(e.target.value);
		}
		
		const validateGstHandler=(e)=>{
			if(e.target.name ==='gstno'){
				SetGstNo(e.target.value.toUpperCase().replace(/[^a-z0-9]/gi, ''));	
				//SetErrors({...errors, gstNumberError: false});
			}
			if(e.target.value.length===15){
				const gstJson = {
					gst_no : e.target.value
				}
				axios.post(API_URL+'pos/api/UserExist',gstJson,{
				   auth: {username:'az_live@autozilla.com',
						  password:'4cslC166sb2A63FmO7Jh65z0N3Zh1ZL8'},
				  headers : {           
					'Content-Type' : 'application/json'
				  }
				})
				.then(res => {
					if(res.data.id>0){
						SetGstExist(true);					
					}else{
						SetGstExist(false);	
					}	  
				});	
			}else{
				SetGstExist(false);			
			}
		}

		const verifyButtonHandler =(e)=>{
			e.preventDefault();		
		   if(enteredOwnerContactNumber.current.value.length ===10){
			   SetMobileValid(true);
			   SetShowOtpInput(true);
			   let randomOtp = (Math.floor(Math.random() * 10000) + 10000).toString().substring(1);
			   console.log(randomOtp);
			   SetOtpSent(randomOtp);
			   
			   const otpJson = {
				   mobile_number : enteredOwnerContactNumber.current.value,
				   otp : randomOtp
			   }
			   
		   axios.post(API_URL+'pos/api/SendOtp',otpJson,{
			  auth: {username:'az_live@autozilla.com',
					 password:'4cslC166sb2A63FmO7Jh65z0N3Zh1ZL8'},
			 headers : {           
			   'Content-Type' : 'application/json'
			   }
		   })
		   .then(res => {
			   //console.log(res);	  
		   });
			   
			   //console.log(enteredOwnerContactNumber.current.value);
		   }else{
			   SetMobileValid(false);
		   }
	   }

	   const resendOTP = (e) => {
		
		if(enteredOwnerContactNumber.current.value.length ===10){
			SetMobileValid(true);
			SetShowOtpInput(true);
			let randomOtp = (Math.floor(Math.random() * 10000) + 10000).toString().substring(1);
			console.log(randomOtp);
			SetOtpSent(randomOtp);
			
			const otpJson = {
				mobile_number : enteredOwnerContactNumber.current.value,
				otp : randomOtp
			}
			
		axios.post(API_URL+'pos/api/SendOtp',otpJson,{
		   auth: {username:'az_live@autozilla.com',
                  password:'4cslC166sb2A63FmO7Jh65z0N3Zh1ZL8'},
		  headers : {           
            'Content-Type' : 'application/json'
			}
		})
		.then(res => {
			//console.log(res);	  
		});
			
			//console.log(enteredOwnerContactNumber.current.value);
		}else{
			SetMobileValid(false);
		}
	  };

	  const validateMobileNumber = (e)=>{
		const re = /^[0-9\b]+$/;
		if (e.target.value === '' || re.test(e.target.value)) {
         SetMobileNo(e.target.value);
		}
		SetErrors({...errors, ownerContactNumError: false});
		
		if(e.target.value.length===10){
			const mobileJson = {
				mobile : e.target.value
			}
			axios.post(API_URL+'pos/api/UserExist',mobileJson,{
			   auth: {username:'az_live@autozilla.com',
					  password:'4cslC166sb2A63FmO7Jh65z0N3Zh1ZL8'},
			  headers : {           
				'Content-Type' : 'application/json'
			  }
			})
			.then(res => {
				if(res.data.id>0){
					SetCustomerExist(true);					
				}else{
					SetCustomerExist(false);	
				}	  
			});	
			
			SetMobileValid(true);
		}else{
			SetMobileValid(false);
			SetCustomerExist(false);
		}

	}
	const verifyMobileHandler = (e)=>{
		e.preventDefault();
		//console.log(otpSent);
		//console.log(OTP);
		if(otpSent===OTP){
		   SetMobileVerified(true);
		   SetShowOtpInput(false);
		   SetOtpMatched(true);
		}else{
		   SetMobileVerified(false);
		   SetOtpMatched(false);
		}
   }

		const filesSelectHandler = (event)=>{
			//console.log(event.target.files);
			const addedFile = event.target.files[0];
			setPictures((pictures) => [...pictures, addedFile]);
			//setPictures(picturesArr);	
		}
		const deleteImage = (index)=>{
			setPictures((pictures) => pictures.filter((item)=> item.name !== index));
		}

		const validateHandler = (e)=>{
			if(e.target.name ==='area_operations'){
				SetErrors({...errors, areaOperationsError: false});
			}
			if(e.target.name ==='owner_name'){
				SetErrors({...errors, ownerNameError: false});
			}
			if(e.target.name ==='owner_email'){
				SetErrors({...errors, ownerEmailError: false});
			}	
			if(e.target.name ==='manager_email'){
				SetErrors({...errors, managerEmailError: false});
			}
			if(e.target.name ==='manager_contact'){
				const re = /^[0-9\b]+$/;
				if (e.target.value === '' || re.test(e.target.value)) {
					SetManagerContact(e.target.value);
				}
				SetErrors({...errors, managerContactError: false});
			}
			if(e.target.name ==='zipcode'){
				const re = /^[0-9\b]+$/;
				if (e.target.value === '' || re.test(e.target.value)) {
					SetPostcode(e.target.value);
				}
				SetErrors({...errors, zipError: false});
			}
		

		}
		const citySelectHandler=(e)=>{
			SetErrors({...errors, cityError: false});
		}

		const addressChangeHandler =(e)=>{
			SetAppendAddress(e.target.value);
			SetErrors({...errors, addressError: false});
		}

		//Location AutoSearch Starts Here!
		const {
		ready,
		value,
		suggestions: { status, data },
		setValue,
		clearSuggestions,
	  } = usePlacesAutocomplete({
		requestOptions: {
		  /* Define search scope here */
		  },
		debounce: 300,
	});
	  
	const ref = useOnclickOutside(() => {   
		clearSuggestions();
	});
	  
	const handleInput = (e) => {
    // Update the keyword of the input element
		setValue(e.target.value);
		SetErrors({...errors,NameError: false});	
	};
  
   const handleSelect = ({ description }) => () => {
	setValue(description, false);	
    clearSuggestions();
    // Get latitude and longitude via utility functions
    getGeocode({ address: description })
      .then((results) => getLatLng(results[0]))
      .then(({ lat, lng }) => {
       setCurrentLoc({
				 lat: lat,
				 lng: lng,
			   });
			   formattedAddress(lat,lng);
      })
      .catch((error) => {
        console.log("😱 Error: ", error);
      });
  };
  
   const renderSuggestions = () =>
    data.map((suggestion) => {
      const {
        place_id,
        structured_formatting: { main_text, secondary_text },
      } = suggestion;
      return (
        <li key={place_id} onClick={handleSelect(suggestion)}>
          <strong>{main_text}</strong> <small>{secondary_text}</small>
        </li>
      );
    });
	//Location AutoSearch Ends Here!
	function getAddressParts(obj) {
		const address = [];
	
		obj.address_components.forEach( function(el) {
			address[el.types[0]] = el.long_name;
		});	
		return address;	
	}
	const formattedAddress = (latitude,longitude) =>{
		axios.get('https://maps.googleapis.com/maps/api/geocode/json?latlng='+latitude+','+longitude+'&sensor=false&key=AIzaSyBFKu4yPFxXLZeV7Zu872o3vzjp8vfvOLg'
		  )
		  .then(res => {
			  const resdata = res.data.results[0].address_components; 
			  
			  const addressParts =  getAddressParts(res.data.results[0]);
			  const city = addressParts.locality;			
			  const state = addressParts.administrative_area_level_1;
			  const country = addressParts.country;	
			  const postal_code = addressParts.postal_code;		
			  SetAppendAddress(res.data.results[0].address_components[1].long_name+', '+res.data.results[0].address_components[2].long_name);
			  //console.log(state);	
			 // console.log(res.data.results[0].address_components[3]['long_name']);				
		  });
	}
	const getDate = (dateStr) => {
		if (dateStr !== undefined) {
		  var date = new Date(dateStr),
			mnth = ("0" + (date.getMonth() + 1)).slice(-2),
			day = ("0" + date.getDate()).slice(-2);
		  return [date.getFullYear(), mnth, day].join("-");
		} else {
		  return "";
		}
	  } 
	const submitHandler = (e)=>{
		e.preventDefault();	
		/*---Validations starts here!---*/
		if(enteredName.current.value.trim().length===0){
			SetErrors({...errors,NameError: true});	
			toast('Please enter Name!');
			return;		
		}
		if(enteredAreaOfOperations.current.value.trim().length===0){
			SetErrors({...errors,areaOperationsError: true});	
			toast('Please enter Area of operations!');
			return;		
		}
		if(enteredOwnerEmailId.current.value.trim().length===0){
			SetErrors({...errors,ownerEmailError: true});
			toast('Please enter Owner Email!');	
			return;		
		}
		if(enteredOwnerContactNumber.current.value.trim().length===0){
			SetErrors({...errors,ownerContactNumError: true});	
			toast('Please enter Owner Contact number!');
			return;		
		}
		if(enteredOwnerName.current.value.trim().length===0){
			SetErrors({...errors,ownerNameError: true});
			toast('Please enter Owner Name!');	
			return;		
		}
		
		if(enteredManagerEmailId.current.value.trim().length===0){
			SetErrors({...errors,managerEmailError: false});	
			//toast('Please enter Manager Email!');
			//return;		
		}
		if(enteredManagerContactNumber.current.value.trim().length===0){
			SetErrors({...errors,managerContactError: false});	
			//toast('Please enter Manager Contact number!');
			//return;		
		}
		
		if(enteredAddress.current.value.trim().length===0){
			SetErrors({...errors,addressError: true});	
			toast('Please enter Address!');
			return;		
		}
		if(enteredState.current.value.trim().length===0){
			SetErrors({...errors,stateError: true});
			toast('Please select State!');	
			return;		
		}
		if(enteredCity.current.value.trim().length===0){
			SetErrors({...errors,cityError: true});	
			toast('Please select City!');
			return;		
		}
		if(enteredZipcode.current.value.trim().length===0){
			SetErrors({...errors,zipError: true});	
			toast('Please enter zipcode!');
			return;		
		}
		
		if(gstExist===true){
			return;
		}
		if(customerExist===true){
			return;
		}
		if(mobileVerified===false){		
			toast("Please verify owner mobile no!");
			return;
		}
		

		const config = {
			bucketName: S3_BUCKET_NAME,
			dirName: 'seller_agreements', /* optional */
			region: 'ap-south-1',
			accessKeyId: 'AKIA2WD2BJFCHHBF42QB',
			secretAccessKey: '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',
			s3Url:'https://s3-ap-south-1.amazonaws.com/',
	  }
	  
	  var filesStr = ''; 
	  if(pictures.length>0){
		  for (let i = 0; i < pictures.length; i++) {
			const d = new Date();
			let ms = d.valueOf();
			var fileExtension = '.' + pictures[i]['name'].split('.')[1];
			var prefix= pictures[i]['name'].split('.')[0];
			var name= prefix+ms+ fileExtension;
			var blob = pictures[i].slice(0, pictures[i].size, pictures[i].type);
			var newFile = new File([blob], name, {type: pictures[i].type});			
			filesStr += name+',';
			  S3FileUpload.uploadFile(newFile,config)
			  .then((data)=>{
				  console.log(data.location);	
			  }).catch((err)=>{
				  alert(err);
			  })
			//formData.append("file[]", pictures[i]);
		  }
	  }

		/*---Validations ends here!---*/

		const sellerJson = {
			sellerName : enteredName.current.value,
			areaofOperations : enteredAreaOfOperations.current.value,
			ownerContactNumber : enteredOwnerContactNumber.current.value,
			ownerEmail : enteredOwnerEmailId.current.value,
			owner_name : enteredOwnerName.current.value,
			manager_name : enteredManagerName.current.value,
			business_type : enteredBusinessType.current.value,
			managerContactNumber : enteredManagerContactNumber.current.value,
			managerEmail : enteredManagerEmailId.current.value,
			gstNo : enteredGstNumber.current.value,
			address : enteredAddress.current.value,
			landmark:enteredLandMark.current.value,
			state : enteredState.current.value,
			city : enteredCity.current.value,
			zipcode : enteredZipcode.current.value,
			geocode : enteredGeocode.current.value,
			categories : selectedCategories,
			brands : selectedBrands,
			discount_structure : enteredDiscount.current.value,
			payment_terms : selectedPaymentTerm,
			discount_type :enteredDiscountType.current.value,
			fieldSalesStaff : enteredFieldSalesStaff.current.value,
			localSalesStaff : enteredLocalSalesStaff.current.value,
			catalog_availability : catalogAvailable,
			logistical_support : logisticalSupport,
			current_system : enteredCurrentSystem.current.value,
			api_integration : apiIntegration,
			stock_update : stockUpdate,
			willing_to_use : willingToUse,
			owner_birth:getDate(dateValue),
			owner_wedding : getDate(weddingDateValue),
			files_list : filesStr
		}
		//console.log(sellerJson);

		axios.post(API_URL+'pos/api/CreateSeller',sellerJson,{
			auth: {username:'az_live@autozilla.com',
				   password:'4cslC166sb2A63FmO7Jh65z0N3Zh1ZL8'},
		   headers : {           
			 'Content-Type' : 'application/json'
		   }
		 })
		 .then(res => {
			 if(res.data){
				// console.log(res.data);
				 toast('Seller onboarded successfully!');
				 //window.location.reload();
				setTimeout(function(){window.location.reload()} , 3000);
			 }else{
				toast(res.data.message);
			 }	  
		 });
	}
	if(sessionStorage.getItem('user_id')>0){
	 return <Fragment>
		 <div className='sign_up'>
			<div>   
			<ToastContainer />        
			<form className='container'> 
				<div className='row'>
				<div className="col-sm-12">
				{/* SEction Start Here */}
				<div className='bg_m1'>
				<div className='row'>
				<div className="col-sm-12 gradent_m2">
					<h4 className='head_m1'>Seller Information</h4>	
				</div>
				
				<div className='col-sm-4'>
					<div className='input_m1'>
						<label>Name</label>
					
						<input type="text"  
								  ref={enteredName}  
								className = {`${ errors.NameError && classes.invalid}`}/>
					
									
					</div>
				</div>
				
				<div className='col-sm-4'>
					<div className='input_m1'>
						<label>Area of Operations</label>
						<input type="text" name="area_operations" ref={enteredAreaOfOperations} onChange={validateHandler}
						className = {`${ errors.areaOperationsError && classes.invalid}`}/>					
					</div>
				</div>
				<div className='col-sm-4'>
					<div className='input_m1'> 
						<label>GST Number</label>
						<input type="text" onChange ={validateGstHandler} name="gstno"  maxLength="15"  value={gstNo} ref={enteredGstNumber}/>
							{gstExist===true &&
								<p className='error_msg'>Customer already exist.</p>
							}
					</div>
				</div>
				<div className='col-sm-4'>
					<div className='input_m1'>
						<label>Owner Email ID</label>
						<input type="text" name = "owner_email" ref={enteredOwnerEmailId} onChange={validateHandler}
						className = {`${ errors.ownerEmailError && classes.invalid}`}/>					
					</div>
				</div>

				<div className='col-sm-4 '>
					<div className='input_m1 input_m2'> 
						<label>Owner Contact No.</label>
						<input type="text" onChange ={validateMobileNumber} pattern="[0-9]*" 
						name="owner_mobile_no" maxLength="10" value={mobileNo}  
						ref={enteredOwnerContactNumber} required 
						className = {`${ errors.ownerContactNumError && classes.invalid}`}/>
						{mobileValid ===false &&
							<p className='error_msg'>Please enter valid number</p>
						}
						{otpMatched ===false &&
							<p className='error_msg'>Please enter correct Otp.</p>
						}
						{customerExist ===true &&
							<p className='error_msg'>Customer already exist.</p>
						}
						{ mobileVerified ===false &&
						<button onClick={verifyButtonHandler} className="btn_s1">Get OTP</button>
						}
						{mobileVerified=== true &&
						<span className="verified_text"><img src={VerifyIcon} /></span>
						}
					</div>
				</div>
				
				<div className='col-sm-4 otp_set'>
					{ showOtpInput===true &&				
						<div className='input_m1'> 
						<OTPInput
						  value={OTP}
						  onChange={sellerOTP}
						  autoFocus
						  OTPLength={4}
						  otpType="number"					
						   className='otp_main'
						/>
						<span className="otp_resend">
						<button onClick={verifyMobileHandler} className='otp_verify btn_s2 mt-1'>Verify</button>
						<ResendOTP onResendClick={(e) => resendOTP(e)} />
						
						</span>
						</div>
					}
					
				</div>
						
				<div className='col-sm-12'></div>
				<div className='col-sm-4'>
					<div className='input_m1'> 
						<label>Owner Name</label>
						<input type="text"  name="owner_name"  
						ref={enteredOwnerName}
						onChange={validateHandler}
						className = {`${ errors.ownerNameError && classes.invalid}`} />
					</div>
				</div>
				<div className='col-sm-4'>
					<div className='input_m1'> 
						<label>Manager Name</label>
						<input type="text" name="manager_name"  ref={enteredManagerName}/>
					</div>
				</div>
				<div className='col-sm-4'>
					<div className='input_m1'> 
						<label>Business Type</label>
						<select onChange={businessTypeSelectHandler} ref={enteredBusinessType}>
							<option key="1" value="1">Manufacturer</option>	
							<option key="2" value="2">Distributor</option>	
							<option key="3" value="3">Stockist</option>	
							<option key="4" value="4">Retailer</option>
							<option key="6" value="6">Franchisor</option>	
							<option key="7" value="7">Hub</option>
							<option key="8" value="8">Fleethub</option>				
						</select>
					</div>
				</div>
				<div className='col-sm-12'></div>
				<div className='col-sm-4'>
					<div className='input_m1'>
						<label>Manager Email ID</label>
						<input type="text" name ="manager_email"
						ref={enteredManagerEmailId}
						onChange={validateHandler}
						 className = {`${ errors.managerEmailError && classes.invalid}`}/>					
					</div>
				</div>

				<div className='col-sm-4'>
					<div className='input_m1'>
						<label>Manager Contact number</label>
						<input type="text" name="manager_contact"
						 maxLength={10} pattern="[0-9]*" 
						 value={managerContact}
						ref={enteredManagerContactNumber}
						onChange={validateHandler}
						 className = {`${ errors.managerContactError && classes.invalid}`}/>					
					</div>
				</div>		
				
			</div>
			</div>
			{/* SEction End Here */}
			
			{/* SEction Start Here */}
				<div className='bg_m1'>
				<div className='row'>
				<div className="col-sm-12 gradent_m2">
					<h4 className='head_m1'>Address Details</h4>	
				</div>
				<div className='col-sm-6'>
					<div className='row'>
						
						<div className='col-sm-12'>
							<div className='input_m1'> 
								<label>Address</label>							
								<textarea name ="address" value={appendAddress}	
								onChange ={addressChangeHandler}							
								ref={enteredAddress} rows="1"
								className = {`${ errors.addressError && classes.invalid}`}>									
								</textarea>
							
							</div>
						</div>
						<div className='col-sm-12'>
							<div className='input_m1'> 
								<label>Land Mark</label>
								<input type="text" name="land_mark" ref={enteredLandMark} />
							</div>
						</div>
						<div className='col-sm-12'>
							<div className='input_m1'> 
								<label>State</label>
								<select onChange={stateSelectHandler} ref={enteredState}>
									{states.map((state) => (
									<option key={state.state_id} value={state.state_id}>{state.state}</option>
									))}						
								</select>
							</div>
						</div>

						<div className='col-sm-12'>
							<div className='input_m1'> 
								<label>City</label>
								<select ref={enteredCity}
								className = {`${ errors.cityError && classes.invalid}`}
								onChange={citySelectHandler} >
								{cities.map((city) => (
									<option key ={city.city_id} value={city.city_id}>{city.city}</option>
									))}
								</select>
							</div>
						</div>
						<div className='col-sm-12'>
							<div className='input_m1'> 
								<label>Zip Code</label>
								<input type="text" name="zipcode" 
								 maxLength={6} pattern="[0-9]*" 
								 value={postcode}
								ref={enteredZipcode} onChange={validateHandler}
								className = {`${ errors.zipError && classes.invalid}`} />
							</div>
						</div>
					</div>
				</div>

					<div className='col-sm-6'>						 
						<div className='input_m1'> 
							<label>Lat/Longitude</label>						 
							<input type="text" name="geocode" value={currentLoc.lat+', '+currentLoc.lng} ref={enteredGeocode}/>
						</div>	
						<div className='input_m1'> 
								<div ref={ref}>
								
									<input type="text" 
									name="serach_address" 
									placeholder="Search address here.."
									value={value} 
									onChange={handleInput} />
								{status === "OK" && <ul>{renderSuggestions()}</ul>}
								</div>
							</div>			
						
						  <GoogleMap
							mapContainerStyle={containerStyle}
							center={{ lat: currentLoc.lat, lng: currentLoc.lng }}
							zoom={15}							
						  >
							{/* Child components, such as markers, info windows, etc. */}
							 <Marker
								position={currentLoc}
							  >									
							  </Marker>
						  </GoogleMap>
						
						
					</div>	
								
				</div>					 
				</div>
				{/* SEction End Here */}
			
			{/* SEction Start Here */}
			<div className='bg_m1'>
				<div className='row'>
				<div className="col-sm-12 gradent_m2">
					<h4 className='head_m1'>Parts Assortment Details</h4>	
				</div>
				
				<div className='col-sm-4'>
					<div className='input_m1'>
						<label>Category of parts sold</label>
						<Select		
							  isMulti={true}
							  onChange={categorySelectHandler}
							options={categories}
						
						/>		
					</div>
				</div>
				
				<div className='col-sm-4'>
					<div className='input_m1'>
						<label>Brands sold</label>
						
						<Select		
							  isMulti={true}
							  onChange={brandSelectHandler}
							options={brands}
						
						/>	
						
										
					</div>
				</div>
				<div className='col-sm-4'>
					<div className='input_m1'> 
						<label>Discount Type</label>
						<select ref={enteredDiscountType}>
						<option key={0} value="">Select Discount Type</option>
						<option key={1} value="mrp_gst">MRP+GST</option>	
						<option key={2} value="disc_mrp">DISC ON MRP</option>	
						<option key={3} value="list_price">LIST PRICE</option>					
						</select>
					</div>
				</div>	
				<div className='col-sm-4'>
					<div className='input_m1'>
						<label>Discount structure to Autozilla</label>
						<input type="number" min='0' ref={enteredDiscount} />					
					</div>
				</div>
				
			</div>
			</div>
			{/* SEction End Here */}
			
			{/* SEction Start Here */}
			<div className='bg_m1'>
				<div className='row'>
				<div className="col-sm-12 gradent_m2">
					<h4 className='head_m1'>Billing Details</h4>	
				</div>
				
				<div className='col-sm-4'>
					<div className='input_m1'>
						<label>Payment terms </label>
						<Select		
						  onChange={paymentTermsSelectHandler}
							options={paymentTerms}
						/>					
					</div>
				</div>
				
				
				
			</div>
			</div>
			{/* SEction End Here */}
			{/* SEction Start Here */}
			<div className='bg_m1'>
				<div className='row'>
				<div className="col-sm-12 gradent_m2">
					<h4 className='head_m1'>Staff & Support information</h4>	
				</div>
				
				<div className='col-sm-4'>
					<div className='input_m1'>
						<label>No of field sales staff </label>
						<input type="number" min="0" ref={enteredFieldSalesStaff}/>					
					</div>
				</div>
				<div className='col-sm-4'>
					<div className='input_m1'>
						<label>No of local sales staff </label>
						<input type="number" min="0" ref={enteredLocalSalesStaff} />					
					</div>
				</div>	
				<div className='col-sm-12'></div>
				<div className='col-sm-4 col-md-3'>
						<div className='toggle_btn1'> 
							<label>Catalogue availability </label>
							<div className='selector'>
								<div className='selecotr-item'>
									<input type="radio" id="catalog_avail_yes" name="catalog_avail" className='selector-item_radio' onChange={catalogAvailChangeHandler} value='Yes'  />
									<label htmlFor="catalog_avail_yes" className='selector-item_label'>Yes</label>
								</div>
								<div className='selecotr-item'>
									<input type="radio" id="catalog_avail_no" name="catalog_avail" className='selector-item_radio' onChange={catalogAvailChangeHandler} value='No' defaultChecked/>
									<label htmlFor="catalog_avail_no" className='selector-item_label'>No</label>
								</div>
								
							</div>
						</div>
					</div>
				
					<div className='col-sm-4 col-md-3'>
						<div className='toggle_btn1'> 
							<label>Own Logistical support</label>
							<div className='selector'>
								<div className='selecotr-item'>
									<input type="radio" id="logistical_yes" name="own_logistical" className='selector-item_radio' onChange={logisticalChangeHandler} value='Yes'  />
									<label htmlFor="logistical_yes" className='selector-item_label'>Yes</label>
								</div>
								<div className='selecotr-item'>
									<input type="radio" id="logistical_no" name="own_logistical" className='selector-item_radio' onChange={logisticalChangeHandler} value='No' defaultChecked/>
									<label htmlFor="logistical_no" className='selector-item_label'>No</label>
								</div>
								
							</div>
						</div>
					</div>
				
				
			</div>
			</div>
			{/* SEction End Here */}
			
			{/* SEction Start Here */}
			<div className='bg_m1'>
				<div className='row'>
				<div className="col-sm-12 gradent_m2">
					<h4 className='head_m1'>Other fields</h4>	
				</div>
				
				<div className='col-sm-4'>
					<div className='input_m1'>
						<label>Current system </label>
						<input type="text" ref={enteredCurrentSystem} />					
					</div>
				</div>
				
				<div className='col-sm-4'>
					<div className='input_m1'>
						<label>Owner Birthday </label>
						<DatePicker onChange={dateChangeHandler} value={dateValue} ref={enteredOwnerBirthday}/>					
					</div>
				</div>
				<div className='col-sm-4'>
					<div className='input_m1'>
						<label>Owner Wedding anniversary </label>
						<DatePicker onChange={weddingDateChangeHandler} value={weddingDateValue} ref={enteredOwnerWedding}/>				
					</div>
				</div>
				<div className='col-sm-12'></div>
				<div className='col-sm-4 col-md-3'>
					<div className='toggle_btn1'> 
						<label>API Integration</label>
						<div className='selector'>
							<div className='selecotr-item'>
								<input type="radio" id="api_integration_yes" name="api_integration" className='selector-item_radio'  onChange={apiIntegrationChangeHandler} value='Yes'  />
								<label htmlFor="api_integration_yes" className='selector-item_label'>Yes</label>
							</div>
							<div className='selecotr-item'>
								<input type="radio" id="api_integration_no" name="api_integration" className='selector-item_radio'  onChange={apiIntegrationChangeHandler} value='No' defaultChecked/>
								<label htmlFor="api_integration_no" className='selector-item_label'>No</label>
							</div>
							
						</div>
					</div>
				</div>
				
				<div className='col-sm-4 col-md-3'>
					<div className='toggle_btn1'> 
						<label>Willingness to use AZ App</label>
						<div className='selector'>
							<div className='selecotr-item'>
								<input type="radio" id="willing_touse_az_yes" name="willing_touse_az" className='selector-item_radio' onChange={willingtoUseChangeHandler} value='Yes'  />
								<label htmlFor="willing_touse_az_yes" className='selector-item_label'>Yes</label>
							</div>
							<div className='selecotr-item'>
								<input type="radio" id="willing_touse_az_no" name="willing_touse_az" className='selector-item_radio' onChange={willingtoUseChangeHandler} value='No' defaultChecked/>
								<label htmlFor="willing_touse_az_no" className='selector-item_label'>No</label>
							</div>
							
						</div>
					</div>
				</div>		
				
				<div className='col-sm-4 col-md-3'>
					<div className='toggle_btn1'> 
						<label>Regular stock updation in AZ App</label>
						<div className='selector'>
							<div className='selecotr-item'>
								<input type="radio" id="stock_update_yes" name="stock_update" className='selector-item_radio'  onChange={stockUpdateChangeHandler} value='Yes'  />
								<label htmlFor="stock_update_yes" className='selector-item_label'>Yes</label>
							</div>
							<div className='selecotr-item'>
								<input type="radio" id="stock_update_no" name="stock_update" className='selector-item_radio'  onChange={stockUpdateChangeHandler} value='No' defaultChecked/>
								<label htmlFor="stock_update_no" className='selector-item_label'>No</label>
							</div>
							
						</div>
					</div>
				</div>
				
				
				
				
			</div>
			</div>
			{/* SEction End Here */}

			{/* SEction Start Here */}
			<div className='bg_m1'>
				<div className='row'>
				<div className="col-sm-12 gradent_m2">
					<h4 className='head_m1'>Upload Agreement</h4>	
				</div>
				
				<div className='col-sm-12'>
					<div className='garage_up'>
						<label>Sign off - Agreement</label>
						<div className="upload-btn-wrapper">
							<button className="btn"><i className="fa fa-plus-circle" aria-hidden="true"></i></button>
							<input type="file" multiple onChange ={filesSelectHandler}/>
						</div>
					</div>
					<div className='garage_pics'>								
						<div className = {classes.image_box}>
								{pictures.map((img,i) => (
									<div className="upload_result" key={i}>
										<i className="fa fa-times-circle" aria-hidden="true" onClick={() => deleteImage(img.name)} ></i>
										<p className={classes.img_preview}  key={i} >{img.name}</p>
									</div>
								))}										
						</div>
					</div>						
							
				</div>
				
			</div>
			</div>
			{/* SEction End Here */}
			
				<div className='col-sm-12 text-center mt-5 mb-5'>
					<button className="btn btn_m1" onClick={submitHandler}>Onboard Seller</button>
				</div>
			</div>
			</div>
				
			</form>
			</div>
			<div className="right_set">
				<img src={BottomBgm} />
			</div>
			</div>
	 </Fragment>
	}else{
		return (           
			<div className={classes.mainLogin}>
				<div className="container-fluid">
				<div className="row  mt-5">
					<div className="col-sm-4 offset-sm-4 mt-4 mb-4">
			<img src= {AuthLogo} alt='Auto Parts By Autozilla' className="w-100"/>
			<p className="mt-3 text-center"><b>Authentication Required to access the Catalog</b></p>
			</div>
			</div>
			</div>                    
			</div>    
			
			
		);
	}
	
}

export default SellerForm;